"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeedtestApiImpl = void 0;
var ApiImplBase_1 = require("./ApiImplBase");
var SpeedtestApiImpl = /** @class */ (function (_super) {
    __extends(SpeedtestApiImpl, _super);
    function SpeedtestApiImpl(baseUrl, apiKey, logger, defaultTimeout) {
        return _super.call(this, baseUrl, apiKey, logger, defaultTimeout) || this;
    }
    SpeedtestApiImpl.prototype.abort = function (speedtestId) {
        return this.requestRx("/abort/".concat(encodeURIComponent(speedtestId)), "GET", undefined, 2000);
    };
    SpeedtestApiImpl.prototype.backgroundRadioStats = function (backgroundRadioStatsModel) {
        return this.requestRx("/backgroundRadioStats/", "POST", backgroundRadioStatsModel);
    };
    SpeedtestApiImpl.prototype.calcBenchmark = function (calcBenchmarkRequestModel) {
        return this.requestRx("/calc/benchmark/", "PUT", calcBenchmarkRequestModel);
    };
    SpeedtestApiImpl.prototype.calcDownload = function (calcDownloadRequestModel) {
        return this.requestRx("/calc/download/", "PUT", calcDownloadRequestModel);
    };
    SpeedtestApiImpl.prototype.calcPageSpeed = function (calcPageSpeedRequestModel) {
        return this.requestRx("/calc/pageSpeed/", "PUT", calcPageSpeedRequestModel);
    };
    SpeedtestApiImpl.prototype.calcPing = function (calcPingRequestModel) {
        return this.requestRx("/calc/ping/", "PUT", calcPingRequestModel);
    };
    SpeedtestApiImpl.prototype.calcUpload = function (calcUploadRequestModel) {
        return this.requestRx("/calc/upload/", "PUT", calcUploadRequestModel);
    };
    SpeedtestApiImpl.prototype.complete = function (completeRequestModel) {
        return this.requestRx("/complete/", "PUT", completeRequestModel);
    };
    SpeedtestApiImpl.prototype.configGet = function () {
        return this.requestRx("/config/", "GET");
    };
    SpeedtestApiImpl.prototype.consentManagement = function (consentManagementModel) {
        return this.requestRx("/consentManagement/", "POST", consentManagementModel);
    };
    SpeedtestApiImpl.prototype.faq = function () {
        return this.requestRx("/faq/", "GET");
    };
    SpeedtestApiImpl.prototype.generateReport = function (printRequestModel) {
        return this.requestBlobRx("/print/", "POST", printRequestModel);
    };
    SpeedtestApiImpl.prototype.initialize = function (initRequestModel) {
        return this.requestRx("/init/", "POST", initRequestModel);
    };
    SpeedtestApiImpl.prototype.modem = function (speedtestId) {
        return this.requestRx("/modem/".concat(encodeURIComponent(speedtestId)), "GET");
    };
    SpeedtestApiImpl.prototype.speedtestSpeedtestIdGet = function (speedtestId) {
        return this.requestRx("/speedtest/".concat(encodeURIComponent(speedtestId)), "GET");
    };
    SpeedtestApiImpl.prototype.tips = function (speedtestId) {
        return this.requestRx("/tips/".concat(encodeURIComponent(speedtestId)), "GET");
    };
    SpeedtestApiImpl.prototype.tipsKeys = function (speedtestId) {
        return this.requestRx("/tipsKeys/".concat(encodeURIComponent(speedtestId)), "GET");
    };
    return SpeedtestApiImpl;
}(ApiImplBase_1.ApiImplBase));
exports.SpeedtestApiImpl = SpeedtestApiImpl;
//# sourceMappingURL=SpeedtestApiImpl.js.map